import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

/**
 * TruFin TruStake APY feed. The same endpoint serves every staker via
 * the `staker` query param — EVM vaults expose `MATIC` (TruMATIC) and
 * `POL` (TruPOL); the remaining stakers (APT, NEAR, INJ, SOL) are
 * non-EVM and not registered here.
 *
 * TruMATIC is transitioning to TruPOL — both vaults remain live on
 * Ethereum, so both yields are fetched.
 */
const APY_URL = 'https://api.trufin.io/staker/apy?staker='

const createTruFinFetcher = (
  staker: string,
  yieldKey: string,
): YieldFetcher => ({
  label: yieldKey,
  fetch: async () => {
    const res = await fetch(APY_URL + staker).then((r) => r.json())
    return { [yieldKey]: apyToAprPercent(res.apy) }
  },
})

export const trumaticFetcher = createTruFinFetcher('MATIC', 'TRUMATIC')
export const trupolFetcher = createTruFinFetcher('POL', 'TRUPOL')
